import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { ApiRoutes } from '../../../../constants/api-routes.constants';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { createEndpointUrl } from '../../../../utilities/pure-functions';
import { messages } from './verify.constants';
import { AuthTemplateComponent } from '../../../organisms/auth-template/auth-template.component';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { RoutesEnum } from '../../../../enums/routes.enum';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  imports: [AuthTemplateComponent, ButtonComponent],
})
export class VerifyComponent implements OnInit {
  public requestState: WritableSignal<RequestStateEnum | null> = signal(null);

  protected RequestStateEnum = RequestStateEnum;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly httpClient: HttpClient,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');

    if (token) {
      this.verifyUser(token);
    } else {
      this.requestState.set(RequestStateEnum.ERROR);
    }
  }

  private verifyUser(token: string): void {
    this.requestState.set(RequestStateEnum.PENDING);
    const url = createEndpointUrl(ApiRoutes.verifyUser);
    const params = new HttpParams().set('token', token);

    this.httpClient
      .get(url, { params })
      .pipe(
        catchError(() => {
          this.requestState.set(RequestStateEnum.ERROR);
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.requestState.set(RequestStateEnum.SUCCESS);
      });
  }

  public getDescription(): string {
    switch (this.requestState()) {
      case RequestStateEnum.SUCCESS:
        return messages.success!;

      case RequestStateEnum.ERROR:
        return messages.error!;

      default:
        return messages.pending!;
    }
  }

  public onClick(): void {
    void this.router.navigateByUrl(RoutesEnum.COMMON_LOGIN);
  }
}
